import {
    TOP_CONTRIBUTORS_REQUESTED,
    TOP_CONTRIBUTORS_SUCCEEDED,
    TOP_CONTRIBUTORS_FAILED,
    TOP_TAGS_REQUESTED,
    TOP_TAGS_FAILED,
    TOP_TAGS_SUCCEEDED,
    ACTIVITY_CALENDAR_REQUESTED,
    ACTIVITY_CALENDAR_SUCCEEDED,
    ACTIVITY_CALENDAR_FAILED,
    PIECES_COLLECTED_REQUESTED,
    PIECES_COLLECTED_SUCCEEDED,
    PIECES_COLLECTED_FAILED,
} from './constants';

const initialState = {
    // initialize empty array for top contributiors
    topContributors: [],
    // initialize boolean to represent topContributors loading state
    contributorsLoading: false,
    // initialize empty arrays for user and ml generated top tags
    topTags: { mlTags: [], userTags: [] },
    // initialize boolean to represent topTags loading state
    tagsLoading: false,
    // initialize integer value for total tags
    totalTags: 0,
    // initialize empty array for yearly activity
    activityData: [],
    // initialize boolean to represent activity calendar loading state
    activityLoading: false,
    // initiliaze integer value for pieces collected
    litterCount: 0,
    // initialize boolean to represent pieces collected loading state
    piecesLoading: false,
    // initialize empty string for selected date
    date: '',
    // initialize empty string for selected taxonomy
    taxonomy: '',
    // initialize empty string for error
    error: '',
};

export default function(state = initialState, action) {
    switch (action.type) {
        case TOP_CONTRIBUTORS_REQUESTED: {
            const { date, customDate } = action;
            const { contributorsLoading } = action;
            return {
                ...state,
                date,
                customDate,
                contributorsLoading,
            };
        }
        case TOP_CONTRIBUTORS_SUCCEEDED: {
            const { topContributors } = action;
            const { contributorsLoading } = action;
            return {
                ...state,
                topContributors,
                contributorsLoading,
            };
        }
        case TOP_CONTRIBUTORS_FAILED: {
            const { error } = action;
            const { contributorsLoading } = action;
            return {
                ...state,
                error,
                contributorsLoading,
            };
        }
        case TOP_TAGS_REQUESTED: {
            const { taxonomy } = action;
            const { tagsLoading } = action;
            return {
                ...state,
                taxonomy,
                tagsLoading,
            };
        }
        case TOP_TAGS_SUCCEEDED: {
            const { topTags } = action;
            const { tagsLoading } = action;
            return {
                ...state,
                ...topTags,
                tagsLoading,
            };
        }
        case TOP_TAGS_FAILED: {
            const { error } = action;
            const { tagsLoading } = action;
            return {
                ...state,
                error,
                tagsLoading,
            };
        }
        case ACTIVITY_CALENDAR_REQUESTED: {
            const { year } = action;
            const { activityLoading } = action;
            return {
                ...state,
                year,
                activityLoading,
            };
        }
        case ACTIVITY_CALENDAR_SUCCEEDED: {
            const { activityData } = action;
            const { activityLoading } = action;
            return {
                ...state,
                activityData,
                activityLoading,
            };
        }
        case ACTIVITY_CALENDAR_FAILED: {
            const { error } = action;
            const { activityLoading } = action;
            return {
                ...state,
                error,
                activityLoading,
            };
        }
        case PIECES_COLLECTED_REQUESTED: {
            const { piecesLoading } = action;
            return {
                ...state,
                piecesLoading,
            };
        }
        case PIECES_COLLECTED_SUCCEEDED: {
            const { litterCount } = action;
            const { piecesLoading } = action;
            return {
                ...state,
                litterCount,
                piecesLoading,
            };
        }
        case PIECES_COLLECTED_FAILED: {
            const { error } = action;
            const { piecesLoading } = action;
            return {
                ...state,
                error,
                piecesLoading,
            };
        }
        default:
            return state;
    }
}
